/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendOtherOpexDto } from '../../models/backend-other-opex-dto';
import { BackendOtherOpexRequestDto } from '../../models/backend-other-opex-request-dto';

export interface OpexesOtheropexUpdate$Params {
  id: number;
  body: BackendOtherOpexRequestDto;
}

export function opexesOtheropexUpdate(
  http: HttpClient,
  rootUrl: string,
  params: OpexesOtheropexUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendOtherOpexDto>> {
  const rb = new RequestBuilder(rootUrl, opexesOtheropexUpdate.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendOtherOpexDto>;
    }),
  );
}

opexesOtheropexUpdate.PATH = '/api/opexes/otheropex/{id}/';
